<template>
  <div class="layout-menu-dialog">
    <div class="kye-dialog-body">
      <div style="width:220px;margin-right:12px;">
        <h3 class="kye-block-title">选择常用模块</h3>
        <div class="tree-box">
          <el-autocomplete
            ref="searchMenu"
            v-model="searchKey"
            placeholder="搜索模块"
            popper-class="kye-popper-auto"
            value-key="$title"
            clearable
            :trigger-on-focus="false"
            :fetch-suggestions="searchMenu"
            @select="selectMenu">
          </el-autocomplete>
          <el-tree
            ref="tree"
            class="tree-content"
            accordion
            highlight-current
            :indent="12"
            node-key="id"
            show-checkbox
            :data="menuTree"
            @check="onCheckClick">
            <span
              :class="`el-tree-node__label ${menuClass(node, data)}`"
              slot-scope="{node, data}">{{data.label}}</span>
          </el-tree>
        </div>
      </div>
      <div style="flex:1;">
        <h3 class="kye-block-title">已选常用模块<span class="tips">（拖动可调整排序）</span></h3>
        <draggable
          ref="draggable"
          class="drag-box"
          :list="tableData"
          v-bind="dragOptions">
          <el-tag
            v-for="(item, index) of tableData"
            :key="item.id"
            :title="item.title && item.title.length > 6 ? item.title : ''"
            closable
            @close="onDelete(item, index)">
            {{item.title}}
          </el-tag>
        </draggable>
      </div>
    </div>
    <div class="el-dialog__footer">
      <el-button type="primary" hotkey="ctrl+s" @click="onSave">保存(S)</el-button>
      <el-button @click="close">取消</el-button>
    </div>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Draggable from 'vuedraggable'

  export default {
    name: 'module-manage',
    components: { Draggable },
    props: {
      menuGroup: Object
    },
    data () {
      return {
        searchKey: '',
        tableData: [],
        dragOptions: {
          draggable: '.el-tag',
          handle: '.el-tag',
          animation: 150,
          ghostClass: 'kye-ghost'
        }
      }
    },
    computed: {
      menus () {
        return this.$store.getters.menus
      },
      menuTree () {
        let arr = this.$store.getters.menus.menuTree || []
        return arr.slice(1).map((item, index) => {
          item.id = `sub_${index}`
          return item
        })
      },
      urls () {
        return this.tableData.map(v => v.url)
      }
    },
    created () {
      this.onOpen()
    },
    methods: {
      searchMenu (val, cb) {
        const res = []
        if (val) {
          Object.values(this.menus).forEach(v => {
            let title = v.$title
            if (title && title.indexOf(val) > -1) {
              res.push(v)
            }
          })
        }
        cb(res)
        // 自动选择第一行
        this.$nextTick(_ => {
          res.length && this.$refs['searchMenu'].highlight && this.$refs['searchMenu'].highlight(0)
        })
      },
      selectMenu (val) {
        if (this.tableData.some(v => v.url === val.menuCode)) {
          this.$message.warning('此模块已存在')
          return false
        }
        this.searchKey = ''
        const newTag = this.buildTag(val.menuCode)
        this.tableData.unshift(newTag)
        this.updateTreeChecked()
      },
      onDelete (item, index) {
        const checkedKeys = this.$refs.tree.getCheckedKeys(true)
        const removeKey = this.menus[item.url].id
        const newCheckedKeys = checkedKeys.filter(key => key !== removeKey)
        this.tableData.splice(index, 1)
        this.$refs.tree.setCheckedKeys(newCheckedKeys)
      },
      async onSave () {
        let itemList = this.tableData.map((v, i) => {
          return { ...v, displaySequence: i + 1, icon: '', moduleType: '10', ...this.menuGroup }
        })
        // 判断是否是新增的
        const isAdd = val => this.cacheData.findIndex(item => item.url === val.url) === -1
        const addList = itemList.filter(item => isAdd(item))
        itemList = itemList.filter(item => !isAdd(item))
        const params = { moduleType: '10', ...this.menuGroup, itemList, addList }
        await this.$http('system.homeIndex.save', params)
        this.$emit('close')
        this.$emit('update', this.tableData)
      },
      close () {
        this.$emit('close')
      },
      async onOpen () {
        // 每次打开都获取最新的收藏模块
        await this.getLinks()
        this.updateTreeChecked()
      },
      async getLinks () {
        try {
          const res = await this.$http('system.homeIndex.list', { moduleType: '10', ...this.menuGroup }, false) || []
          const tableData = res.map(item => this.buildTag(item.url)).filter(Boolean)
          this.tableData = tableData
          this.cacheData = cloneDeep(tableData)
        } catch (e) {
          console.error(e)
        }
      },
      menuClass (node, data) {
        let urls = this.urls
        let url = data.menuCode
        if (node.isLeaf && url && urls.includes(url)) {
          return 'menu-tree-node__label'
        }
        if (!node.isLeaf && node.level === 2 && data.children.some(v => urls.includes(v.menuCode))) {
          return 'menu-tree-node__label'
        }

        return ''
      },
      onCheckClick (data, {checkedNodes}, event) {
        const menus = this.menus
        const currentCheckedKeys = this.tableData.map(item => {
          return menus[item.url].id
        })
        // 获取叶子节点
        const leafMenus = checkedNodes.filter(item => !item.children || !item.children.length)
        if (leafMenus.length < currentCheckedKeys.length) {
          // 删除
          const newCurrentUrls = leafMenus.map(item => item.menuCode)

          this.tableData = this.tableData.filter(item => newCurrentUrls.includes(item.url))
        } else {
          // 新增
          const addTags = leafMenus.filter(item => !currentCheckedKeys.includes(item.id)).map(item => this.buildTag(item.menuCode))
          this.tableData.unshift(...addTags)
        }
      },
      // 更新树的选中状态
      updateTreeChecked () {
        const menus = this.$store.state.menus
        const checkedKeys = this.tableData.map(item => {
          return menus[item.url].id
        })
        this.$refs.tree.setCheckedKeys(checkedKeys)
      },
      // 通过菜单构造tag
      buildTag (menuCode) {
        const menu = this.menus[menuCode]
        if (!menu) return null
        return {
          icon: '',
          title: menu.title,
          url: menu.menuCode
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-dialog {
   .kye-dialog-body {
    display: flex;
    max-height: calc(70vh - 45px);
    .tips {
      color: #999999;
      font-size: 12px;
    }
    .tree-box {
      border: 1px solid #c1bfc7;
      border-radius: 2px;
      padding: 12px;
    }
    .tree-content {
      height: calc(70vh - 180px);
      overflow-y: auto;
      margin-top: 12px;
    }
    .drag-box {
      height: calc(70vh - 115px);
      overflow-y: auto;
      border: 1px solid #c1bfc7;
      border-radius: 2px;
      padding: 12px;
      .el-tag {
        margin: 0 20px 12px 0;
        cursor: move;
        padding-left: 8px;
        padding-right: 8px;
        height: 28px;
        line-height: 28px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        border-radius: 4px;
        color: #333333;
        background: #F3F3FD;
        position: relative;
      }
    }
    .menu-tree-node__label {
      color: #ff9300;
    }

    .drag-box .el-tag .el-icon-close {
      // position: absolute;
      // top: 9px;
      // right: 4px;
      color: #ABABB3;
      // height: 12px;
      // width: 12px;
      // line-height: 12px;
      // transform: none;
      // &:hover {
      //   color: #ffffff;
      //   background-color: #979797;
      // }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/add-menu-dialog.vue